export default __webpack_public_path__ + "static/media/zapier_logo.443b67e3.svg";